import {SERVICES} from '@px/const/services';

const PREFIX_COIN = `${SERVICES.STATIC_URL}/s/web/assets/`;

export const coinUtil = {
  getUrl(coin) {
    coin = ['MUSDT'].includes(coin) ? 'USDT' : coin;
    return PREFIX_COIN + coin + '.svg';
  },
};
